import { decamelize } from "@credify/crypto";
import { CredifyClass } from "./common";
import { BaseResponse } from "./type";

export class PartnerOnboarding extends CredifyClass {
  public async createIndividualEntity(data: {
    accessToken: string;
    signingPublicKey: string;
    currentSigningPublicKey?: string;
  }, market: string): Promise<any> {
    try {
      const res = await this.apiClient.post<BaseResponse>(
        `v2/public/onboarding/${market}`, decamelize(data));

      if (!res.data) {
        throw new Error("Unexpected object");
      }
      return res.data;
    } catch (error) {
      console.log("createIndividualEntity error:", error);
      throw error;
    }
  }
}
